import { useMemo } from 'react';

import useMediaQuery from 'hooks/use-media-query';
import { useAuthContext } from 'state/auth';

export const useShouldShowHero = () => {
  const isMobile = useMediaQuery('mobile');
  const { isAuthenticated } = useAuthContext();
  const authenticated = isAuthenticated();
  return useMemo(() => (authenticated && isMobile ? false : true), [authenticated, isMobile]);
};
